import { useState, useEffect } from "react";

import { get } from "library/endpoints";

/**
 * useTheme
 * @returns 
 */
export default function useTheme() {
  const [theme, setTheme] = useState(null);

  useEffect(() => {
    if (!theme) {
      fetchTheme();
    }
  }, []) // eslint-disable-line

  const fetchTheme = async () => {
    try {
      const {data} = await get('/frontend/theme')      
      setTheme(data)
    } catch (err) {
      console.log(err)
    }
  }

  return {
    theme,
    fetchTheme
  }
}